import React from "react";

// Footer component to appear at bottom of each page
const Footer = () => (
	<div>
		<footer>
			<p>Table Tennis Tournament Generator</p>
			<p>Built by Tim Atherton - View source code <a href="https://github.com/taweb/table-tennis-tool">here</a></p>
		</footer>
	</div>
);

export default Footer;